import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AdminDashboardPageComponent } from './admin-dashboard-page/admin-dashboard-page.component'
import { AdminHeaderComponent } from '../header/admin-header.component'
import { SalesManagerHeaderComponent } from '../header/sales-manager-header.component'
import { RouterModule } from '@angular/router'
import { AdminListSubscriptionsPageComponent } from './admin-list-subscriptions-page/admin-list-subscriptions-page.component'
import { AdminViewSubscriptionComponent } from './admin-view-subscription/admin-view-subscription.component'
import { CoreModule } from '../../shared/core/core.module'
import { AdminListParkingsPageComponent } from './admin-list-parkings-page/admin-list-parkings-page.component'
import { AdminListMerchantsPageComponent } from './admin-list-merchants-page/admin-list-merchants-page.component'
import { AdminListPaymentsPageComponent } from './admin-list-payments-page/admin-list-payments-page.component'
import { ListEmailsPageComponent } from './list-emails-page/list-emails-page.component'
import { AdminListSettlementsPageComponent } from './admin-list-settlements-page/admin-list-settlements-page.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AdminBlogListComponent } from './admin-blog-list/admin-blog-list.component'
import { AdminBlogCreateComponent } from './admin-blog-create-page/admin-blog-create.component'
import { MediaModule } from '../../shared/media/media.module'
import { AdminFunctionsComponent } from './admin-functions/admin-functions.component'
import { NgxChartsModule } from '@swimlane/ngx-charts'
import { AdminScanqrPageComponent } from './admin-scanqr-page/admin-scanqr-page.component'
import { QRCodeModule } from 'angularx-qrcode'
import { AdminGenerateqrPageComponent } from './admin-generateqr-page/admin-generateqr-page.component'
import { AdminViewPaymentPageComponent } from './admin-view-payment-page/admin-view-payment-page.component'
import { AdminListSearchesPageComponent } from './admin-list-searches-page/admin-list-searches-page.component'
import { AdminSubscriptionCreateComponent } from './admin-subscription-create/admin-subscription-create.component'
import { AdminSubscriptionCreateOnBehalfComponent } from './admin-subscription-create-on-behalf/admin-subscription-create-on-behalf.component'
import { ClientSubscriptionsModule } from '../../client/client-subscriptions/client-subscriptions.module'
import { AdminListPayoutsPageComponent } from './admin-list-payouts-page/admin-list-payouts-page.component'
import { MerchantProfileModule } from '../../merchant/merchant-profile/merchant-profile.module'
import { AdminDeputizePageComponent } from './admin-deputize-page/admin-deputize-page.component'
import { AdminSearchesReportComponent } from './admin-searches-report/admin-searches-report.component'
import { AdminSearchesTableComponent } from './admin-searches-table/admin-searches-table.component'
import { TypeaheadModule } from 'ngx-bootstrap/typeahead'
import { AgmCoreModule } from '@agm/core'
import { AdminListExpiredSubscriptionsComponent } from './admin-list-expired-subscriptions/admin-list-expired-subscriptions.component'
import { AdminReconPageComponent } from './admin-recon-page/admin-recon-page.component'
import { AdminAllManualComponent } from './admin-all-manual/admin-all-manual.component'
import { CompaniesByClientComponent } from './reports/companies-by-client/companies-by-client.component'
import { AdminListInvoicesComponent } from './admin-list-invoices/admin-list-invoices.component'
import { AdminCreateInvoiceComponent } from './invoices/admin-create-invoice/admin-create-invoice.component'
import { AdminListExceptionsComponent } from './admin-list-exceptions/admin-list-exceptions.component'
import { AdminListClientsComponent } from './admin-list-clients/admin-list-clients.component'
import { AdminViewExceptionsComponent } from './admin-view-exceptions/admin-view-exceptions.component'
import { AdminInvoicePayoutsComponent } from './admin-invoice-payouts/admin-invoice-payouts.component'
import { AdminSubscriptionManualCreateComponent } from './admin-subscription-manual-create/admin-subscription-manual-create.component'
import { AdminListLeadsComponent } from './admin-list-leads/admin-list-leads.component'
import { AdminListPayoutsComponent } from './admin-list-payouts/admin-list-payouts.component'
import { AdminListPayoutBatchesComponent } from './admin-list-payout-batches/admin-list-payout-batches.component'
import { AdminPayoutBatchDetailsComponent } from './admin-payout-batch-details/admin-payout-batch-details.component'
import { AdminPayoutDetailsComponent } from './admin-payout-details/admin-payout-details.component'
import { AdminEmailDetailsComponent } from './admin-email-details/admin-email-details.component'
import { AdminListMerchantsPrivateComponent } from './admin-list-merchants-private/admin-list-merchants-private.component'
import { AdminListMerchantsMemberInvitesComponent } from './admin-list-merchants-member-invites/admin-list-merchants-member-invites.component'
import { EditParkerComponent } from './crm/edit-parker/edit-parker.component'
import { ParkerCrm } from './crm/parker-crm/parker-crm.component'
import { ParkerTableComponent } from './crm/parker-table/parker-table.component'
import { ParkerStatsComponent } from './crm/parker-stats/parker-stats.component'
import { AdminLineChartsComponent } from './admin-line-charts/admin-line-charts.component'
import { AdminForceVoidPaymentComponent } from './admin-force-void-payment/admin-force-void-payment.component'
import { AdminTestPaymentComponent } from './admin-test-payment/admin-test-payment.component'
import { AdminPaygateLabComponent } from './admin-paygate-lab/admin-paygate-lab.component'
import { AdminPaygateAttemptsComponent } from './admin-paygate-attempts/admin-paygate-attempts.component'
import { AdminListAdmytCentersComponent } from './admin-list-admyt-centers/admin-list-admyt-centers.component'
import { AdminViewAdmytCenterComponent } from './admin-view-admyt-center/admin-view-admyt-center.component'
import { AdminViewAdmytTenantComponent } from './admin-view-admyt-tenant/admin-view-admyt-tenant.component'
import { AdminViewAdmytUserComponent } from './admin-view-admyt-user/admin-view-admyt-user.component'
import { AdminListAdmytUsersComponent } from './admin-list-admyt-users/admin-list-admyt-users.component'
import { AdminListAdmytTenantsComponent } from './admin-list-admyt-tenants/admin-list-admyt-tenants.component'
import { AdminListAdmytLogsComponent } from './admin-list-admyt-logs/admin-list-admyt-logs.component'
import { AdminAdmytAuditComponent } from './admin-admyt-audit/admin-admyt-audit.component'
import { AdminTransparencyComponent } from './admin-transparency/admin-transparency.component'
import { AdminListDuplicateInvoicesComponent } from './admin-list-duplicate-invoices/admin-list-duplicate-invoices.component'
import { ListEmailBySubjectLineComponent } from './list-email-by-subject-line/list-email-by-subject-line.component'
import { AdminListParkingLeadsComponent } from './admin-list-parking-leads/admin-list-parking-leads.component'
import { AdminListClustersComponent } from './admin-list-clusters/admin-list-clusters.component'
import { AdminCreateClusterComponent } from './admin-create-cluster/admin-create-cluster.component'
import { AdminReportingComponent } from './admin-reporting/admin-reporting.component'
import { AdminCampaignsListComponent } from './admin-campaigns/admin-campaigns-list.component'
import { AdminAffiliatesComponent } from './admin-affiliates/admin-affiliates.component'
import { AdminAffiliateDetailComponent } from './admin-affiliates/admin-affiliate-detail.component'
import { AdminAffiliatePayoutsComponent } from './admin-affiliates/admin-affiliate-payouts.component'
import { AdminAffiliateGuideComponent } from './admin-affiliates/admin-affiliate-guide.component'
import { AdminCampaignFormComponent } from './admin-campaigns/admin-campaign-form.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { AdminListRejectionsPageComponent } from './admin-list-rejections-page/admin-list-rejections-page.component'
import { AdminTestRoutesComponent } from './admin-test-routes/admin-test-routes.component'
import { AdminOmnisendErrorsComponent } from './admin-omnisend-errors/admin-omnisend-errors.component'
import { AdminGlobalVariablesComponent } from './admin-global-variables/admin-global-variables.component'
import { AdminFinancialHealthComponent } from './admin-financial-health/admin-financial-health.component'
import { AdminMonthlyDashboardComponent } from './admin-monthly-dashboard/admin-monthly-dashboard.component'
import { AdminMarketingHealthComponent } from './admin-marketing-health/admin-marketing-health.component'
import { AdminAdConversionsComponent } from './admin-ad-conversions/admin-ad-conversions.component'
import { AdminListEnquiriesComponent } from './admin-list-enquiries/admin-list-enquiries.component'
import { AdminUsersListComponent } from './admin-users-list/admin-users-list.component'
import { AdminEnterpriseManagementComponent } from './admin-enterprise-management/admin-enterprise-management.component'
import { EnterprisePageSelectorComponent } from '../components/enterprise-page-selector/enterprise-page-selector.component'
import { EnterpriseAdminBarComponent } from '../components/enterprise-admin-bar/enterprise-admin-bar.component'
import { AdminParkersPageComponent } from './admin-parkers-page/admin-parkers-page.component'
import { AdminEnterpriseAccountsPageComponent } from './admin-enterprise-accounts-page/admin-enterprise-accounts-page.component'
import { AdminEnterpriseSettingsPageComponent } from './admin-enterprise-settings-page/admin-enterprise-settings-page.component'
import { AdminMigrationsComponent } from './admin-migrations/admin-migrations.component'
import { AdminRedefineImporterComponent } from './admin-redefine-importer/admin-redefine-importer.component'
import { AdminMigrateParkingComponent } from './admin-migrate-parking/admin-migrate-parking.component'
import { AdminKnownIssuesComponent } from './admin-known-issues/admin-known-issues.component'
import { AdminApiManagementComponent } from './admin-api-management/admin-api-management.component'
import { AdminTestLocalComponent } from './admin-test-local/admin-test-local.component'
import { AdminDataHygieneComponent } from './admin-data-hygiene/admin-data-hygiene.component'
import { AdminParkingMapComponent } from './admin-parking-map/admin-parking-map.component'
import { ExpiringLeasesComponent } from './crm/expiring-leases/expiring-leases.component'
import { ExpiringLeasesTableComponent } from './crm/expiring-leases-table/expiring-leases-table.component'
import { ExpiringLeasesStatsComponent } from './crm/expiring-leases-stats/expiring-leases-stats.component'
import { ParkerBoardComponent } from './crm/parker-board/parker-board.component'
import { ParkerProfilePanelComponent } from './crm/parker-profile-panel/parker-profile-panel.component'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { NgApexchartsModule } from 'ng-apexcharts'
import { QuillModule } from 'ngx-quill'
import { AdminFaqListComponent } from './admin-cms/admin-faq-list/admin-faq-list.component'
import { AdminFaqEditComponent } from './admin-cms/admin-faq-edit/admin-faq-edit.component'
import { ProspectingNavComponent } from './prospecting/prospecting-nav/prospecting-nav.component'
import { AdminProspectingMapComponent } from './prospecting/admin-prospecting-map/admin-prospecting-map.component'
import { AdminProspectingTableComponent } from './prospecting/admin-prospecting-table/admin-prospecting-table.component'
import { AdminProspectingScraperComponent } from './prospecting/admin-prospecting-scraper/admin-prospecting-scraper.component'
import { AdminProspectingBoardComponent } from './prospecting/admin-prospecting-board/admin-prospecting-board.component'
import { AdminProfileComponent } from './admin-profile/admin-profile.component'
import { AdminProspectingTimelineComponent } from './prospecting/admin-prospecting-timeline/admin-prospecting-timeline.component'
import { AdminProspectingAssistantComponent } from './prospecting/admin-prospecting-assistant/admin-prospecting-assistant.component'
import { AdminProspectingSettingsComponent } from './prospecting/admin-prospecting-settings/admin-prospecting-settings.component'
import { ProspectModalComponent } from './prospecting/prospect-modal/prospect-modal.component'
import { ContactModalComponent } from './prospecting/contact-modal/contact-modal.component'
import { AdminChangelogComponent } from './admin-changelog/admin-changelog.component'
import { AdminMarketInsightsComponent } from './admin-market-insights/admin-market-insights.component'
import { AdminHeatMapComponent } from './admin-heat-map/admin-heat-map.component'
import { AdminAccessAuditComponent } from './admin-access-audit/admin-access-audit.component'

import { AdminBuildingAllocationsComponent } from './admin-building-allocations/admin-building-allocations.component'

@NgModule({
    declarations: [
        AdminBuildingAllocationsComponent,
        AdminDashboardPageComponent,
        AdminHeaderComponent,
        SalesManagerHeaderComponent,
        AdminListClientsComponent,
        AdminListSubscriptionsPageComponent,
        AdminViewSubscriptionComponent,
        AdminListParkingsPageComponent,
        AdminListMerchantsPageComponent,
        AdminListPaymentsPageComponent,
        ListEmailsPageComponent,
        AdminListSettlementsPageComponent,
        AdminBlogCreateComponent,
        AdminBlogListComponent,
        AdminFunctionsComponent,
        AdminScanqrPageComponent,
        AdminGenerateqrPageComponent,
        AdminViewPaymentPageComponent,
        AdminListSearchesPageComponent,
        AdminSubscriptionCreateComponent,
        AdminSubscriptionCreateOnBehalfComponent,
        AdminListPayoutsPageComponent,
        AdminDeputizePageComponent,
        AdminSearchesReportComponent,
        AdminSearchesTableComponent,
        AdminListExpiredSubscriptionsComponent,
        AdminReconPageComponent,
        AdminAllManualComponent,
        CompaniesByClientComponent,
        AdminListInvoicesComponent,
        AdminCreateInvoiceComponent,
        AdminListExceptionsComponent,
        AdminViewExceptionsComponent,
        AdminInvoicePayoutsComponent,
        AdminSubscriptionManualCreateComponent,
        AdminListLeadsComponent,
        AdminListPayoutsComponent,
        AdminListPayoutBatchesComponent,
        AdminPayoutBatchDetailsComponent,
        AdminPayoutDetailsComponent,
        AdminEmailDetailsComponent,
        ParkerCrm,
        AdminListMerchantsPrivateComponent,
        AdminListMerchantsMemberInvitesComponent,
        EditParkerComponent,
        ParkerTableComponent,
        ParkerStatsComponent,
        AdminLineChartsComponent,
        AdminForceVoidPaymentComponent,
        AdminTestPaymentComponent,
        AdminPaygateLabComponent,
        AdminPaygateAttemptsComponent,
        AdminListAdmytCentersComponent,
        AdminViewAdmytCenterComponent,
        AdminViewAdmytTenantComponent,
        AdminViewAdmytUserComponent,
        AdminListAdmytUsersComponent,
        AdminListAdmytTenantsComponent,
        AdminListAdmytLogsComponent,
        AdminAdmytAuditComponent,
        AdminTransparencyComponent,
        AdminListDuplicateInvoicesComponent,
        ListEmailBySubjectLineComponent,
        AdminListParkingLeadsComponent,
        AdminListClustersComponent,
        AdminCreateClusterComponent,
        AdminReportingComponent,
        AdminCampaignsListComponent,
        AdminAffiliatesComponent,
        AdminAffiliateDetailComponent,
        AdminAffiliatePayoutsComponent,
        AdminAffiliateGuideComponent,
        AdminCampaignFormComponent,
        AdminListRejectionsPageComponent,
        AdminTestRoutesComponent,
        AdminOmnisendErrorsComponent,
        AdminGlobalVariablesComponent,
        AdminFinancialHealthComponent,
        AdminMonthlyDashboardComponent,
        AdminMarketingHealthComponent,
        AdminAdConversionsComponent,
        AdminListEnquiriesComponent,
        AdminUsersListComponent,
        AdminEnterpriseManagementComponent,
        EnterprisePageSelectorComponent,
        EnterpriseAdminBarComponent,
        AdminParkersPageComponent,
        AdminEnterpriseAccountsPageComponent,
        AdminEnterpriseSettingsPageComponent,
        AdminMigrationsComponent,
        AdminRedefineImporterComponent,
        AdminMigrateParkingComponent,
        AdminKnownIssuesComponent,
        AdminApiManagementComponent,
        AdminTestLocalComponent,
        AdminParkingMapComponent,
        ExpiringLeasesComponent,
        ExpiringLeasesTableComponent,
        ExpiringLeasesStatsComponent,
        ParkerBoardComponent,
        ParkerProfilePanelComponent,
        AdminDataHygieneComponent,
        AdminFaqListComponent,
        AdminFaqEditComponent,
        ProspectingNavComponent,
        AdminProspectingMapComponent,
        AdminProspectingTableComponent,
        AdminProspectingScraperComponent,
        AdminProspectingBoardComponent,
        AdminProfileComponent,
        AdminProspectingTimelineComponent,
        AdminProspectingAssistantComponent,
        AdminProspectingSettingsComponent,
        ProspectModalComponent,
        ContactModalComponent,
        AdminChangelogComponent,
        AdminMarketInsightsComponent,
        AdminHeatMapComponent,
        AdminAccessAuditComponent,
    ],
    exports: [AdminHeaderComponent, SalesManagerHeaderComponent, EnterprisePageSelectorComponent, EnterpriseAdminBarComponent],
    imports: [
        RouterModule,
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        MediaModule,
        NgxChartsModule,
        QRCodeModule,
        ClientSubscriptionsModule,
        MerchantProfileModule,
        TypeaheadModule,
        FormsModule,
        AgmCoreModule,
        NgSelectModule,
        DragDropModule,
        NgApexchartsModule,
        QuillModule.forRoot({
            modules: {
                toolbar: [
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link'],
                    ['clean'],
                ],
            },
        }),
    ],
})
export class AdminPagesModule {}
